import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fa199d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-group" }
const _hoisted_2 = ["title", "disabled", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "icon"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text" }

import {PropType} from "vue";
import {ButtonData} from "@/lib/components/UI/type/ButtonData";
import {ButtonMargin} from "@/lib/components/UI/enum/ButtonMargin";


export default /*#__PURE__*/_defineComponent({
  name: 'ButtonGroup',
  props: {
  buttons: {
    type: Array as PropType<ButtonData[]>,
    required: true
  },
  margin: {
    type: String as PropType<ButtonMargin>,
    default: ButtonMargin.NONE
  }
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props

_useCssVars(_ctx => ({
  "1725d0da": (__props.margin)
}))






const onButtonClick = (button: ButtonData) => {
  if (!button.isDisabled || !button.isDisabled.value)
    emit('click', button.id)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.buttons, (button, id) => {
      return (_openBlock(), _createElementBlock("button", {
        key: id,
        type: "button",
        class: _normalizeClass('button ' + (button.icon ? 'button-iconed' : '') + ' ' + button.additionalClass),
        title: button.title,
        disabled: button.isDisabled?.value,
        onClick: _withModifiers(($event: any) => (onButtonClick(button)), ["stop"])
      }, [
        (button.icon)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createElementVNode("img", {
                src: button.icon,
                alt: "icon"
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_5, _toDisplayString(button.text), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})